<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">CUSTOMER ASSOCIATION</h1>
		</div>
		<div class="row">
			<div class="col-12">
				<!--LASCIARE ORDINAMENTO SOLO SU COLONNA CLIENTE AS400, LE SELECT DELLE ALTRE DUE COLONNE PARTONO DISABILITATE E IL BTN SALVA NASCOSTO. SI ATTIVA TUTTO AL CLICK SULLA MODIFICA-->
				<table datatable [dtOptions]="dtSettings" [dtTrigger]="dtTrigger" class="row-border hover">
					<thead>
						<tr>
							<th>Customer AS400</th>
							<th>Customer PLM</th>
							<th>Markets</th>
							<th>Evasion Type</th>
							<th>User CS</th>
							<th></th>
						</tr>
					</thead>
					<tbody *ngIf="clienti.length > 0">
						<tr *ngFor="let cliente of clienti">
							<td>{{cliente.ragioneSociale}}</td>
							<td>
								<select
									class="minimal w-100  rounded-0 border-black"
									[disabled]="!cliente.feEdit"
									name="idPlm_{{cliente.id}}"
									[(ngModel)]="cliente.jsonIn.idPlm">
									<option [value]="null">SELECT</option>
									<option *ngFor="let clientePlm of clientiPlm" [value]="clientePlm.id">{{clientePlm.idBertazzoni}}</option>
								</select>
							</td>
							<td>
								<ng-multiselect-dropdown
									*ngIf="mercati"
									[settings]="dropdownSettings"
									[disabled]="!cliente.feEdit"
									class="multiselect-cms w-100"
									[placeholder]="'Select'"
									[(ngModel)]="cliente.mercato"
									[data]="mercati"></ng-multiselect-dropdown>
							</td>
							<td>
								<select
									class="minimal w-100  rounded-0 border-black"
									[disabled]="!cliente.feEdit"
									name="idPlm_{{cliente.id}}"
									[(ngModel)]="cliente.jsonIn.tipoEvasione">
									<option [value]="0">0 - full</option>
									<option [value]="1">1 - partial</option>
								</select>
							</td>
							<td>
								<select
									class="minimal w-100  rounded-0 border-black"
									[disabled]="!cliente.feEdit"
									name="idCS_{{cliente.id}}"
									[(ngModel)]="cliente.jsonIn.idUtenteCustomerSupport">
									<option [value]="null">SELECT</option>
									<option *ngFor="let utente of utenti" [value]="utente.id">{{utente.username}}</option>
								</select>
							</td>
							<td>
								<button
									type="button"
									class="btn btn-bertazzoni black rounded-0"
									*ngIf="cliente.feEdit"
									(click)="save(cliente)"
									[disabled]="!cliente.jsonIn.idPlm || cliente.mercato.length == 0">
									SAVE
								</button>
								<img src="assets/img/pencil.svg" class="action-icon" *ngIf="!cliente.feEdit" (click)="cliente.feEdit = !cliente.feEdit" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
